import { Component, EventEmitter, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFileSpreadsheet, faFileExcel, faCheckCircle, faX } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {
  @Output() onUploadFile: any = new EventEmitter();

  apoFile: any;
  faFileSpreadsheet = faFileSpreadsheet;
  faFileExcel = faFileExcel;
  faCheckCircle = faCheckCircle;
  faX = faX;

  uploadFile(event: any) {
    this.apoFile = event.target.files.item(0);
    this.onUploadFile.emit(this.apoFile);
  }

  removeFile(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.apoFile = null;
    this.onUploadFile.emit(null);
  }

}
